import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const savedCartItems = localStorage.getItem("cartItems");
      return savedCartItems ? JSON.parse(savedCartItems) : [];
    } catch (error) {
      console.error("Failed to parse cart items from localStorage", error);
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
    } catch (error) {
      console.error("Failed to save cart items to localStorage", error);
    }
  }, [cartItems]);

  const addToCart = (productId, quantity, size, options = {}) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find(
        (item) => 
          item.id === productId && 
          item.size === size &&
          item.color === options.color &&
          item.metalType === options.metalType &&
          item.customization === options.customization
      );

      if (existingItem) {
        return prevItems.map((item) =>
          item.id === productId && 
          item.size === size &&
          item.color === options.color &&
          item.metalType === options.metalType &&
          item.customization === options.customization
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      } else {
        const newItem = { 
          id: productId, 
          size, 
          quantity,
          color: options.color || null,
          metalType: options.metalType || null,
          customization: options.customization || null,
          shipDate: options.shipDate || null
        };
        return [...prevItems, newItem];
      }
    });
  };

  const removeFromCart = (productId, size, options = {}) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => !(
        item.id === productId && 
        item.size === size &&
        item.color === options.color &&
        item.metalType === options.metalType &&
        item.customization === options.customization
      ))
    );
  };

  const updateQuantity = (productId, size, quantity, options = {}) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId && 
        item.size === size &&
        item.color === options.color &&
        item.metalType === options.metalType &&
        item.customization === options.customization
          ? { ...item, quantity: Math.max(1, quantity) }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        updateQuantity,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
